import React from "react";
import {
  Buildings,
  Factory,
  Heartbeat,
  GraduationCap,
  Bank,
  Storefront,
  Truck,
} from "@phosphor-icons/react";
import SectionLabel from "../components/SectionLabel";
import { INDUSTRIES } from "../data/content";

const ICONS = [Buildings, Factory, Heartbeat, GraduationCap, Bank, Storefront, Truck];

const Industries = () => {
  return (
    <>
      <section
        className="border-b border-[var(--sifra-line)] bg-white"
        data-testid="industries-hero"
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-8">
            <SectionLabel>Industries We Serve</SectionLabel>
            <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter mt-6 leading-[1]">
              Every sector needs
              <br />
              <span className="text-[var(--sifra-ink-mute)]">reliable hardware.</span>
            </h1>
          </div>
          <div className="md:col-span-4 text-[var(--sifra-ink-soft)]">
            We've equipped corporates across seven core industries — from
            manufacturing floors to hospital wards to boardrooms.
          </div>
        </div>
      </section>

      <section
        className="bg-[var(--sifra-bg)] border-b border-[var(--sifra-line)]"
        data-testid="industries-grid"
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-[var(--sifra-line)] bg-white">
            {INDUSTRIES.map((ind, i) => {
              const Icon = ICONS[i % ICONS.length];
              return (
                <div
                  key={ind}
                  data-testid={`industry-card-${i}`}
                  className="border-r border-b border-[var(--sifra-line)] p-10 min-h-[260px] flex flex-col justify-between hover:bg-[var(--sifra-ink)] hover:text-white transition-colors duration-500 group cursor-default"
                >
                  <Icon size={40} weight="thin" className="text-[var(--sifra-ink)] group-hover:text-white transition-colors" />
                  <div>
                    <div className="text-[11px] tracking-label uppercase text-[var(--sifra-ink-mute)] group-hover:text-white/60 mb-2">
                      Sector / {String(i + 1).padStart(2, "0")}
                    </div>
                    <div className="font-display font-black text-2xl md:text-3xl tracking-tighter">
                      {ind}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default Industries;
